import { AxiosInstance } from 'axios'

type VerifiedDto = {
  name: string
  birthday: string | null
  motherName: string | null
}
type ExistingVerifiedDto = VerifiedDto & {
  id: number
}

type VerifyCpfOutputDto =
  | { patientExists: true; verifiedUser: ExistingVerifiedDto }
  | { patientExists: false; valid: boolean; verifiedUser: VerifiedDto }

export function cpfEndpoints(apiClient: AxiosInstance) {
  return {
    async verify(cpf: string): Promise<VerifyCpfOutputDto> {
      return apiClient.post('verify-cpf', { cpf })
    },
  }
}
